import { accessRole } from "../../../../../helpers/access_role";
import { config } from "../../../../../helpers/config_global";
import React, { useState, Component, Fragment } from "react";
import { Redirect } from "react-router-dom";

import { Tooltip, Modal, ModalHeader, ModalBody } from "reactstrap";
import SimulationComponent from "../../../PresensiAdmin/Detail/Components/SimulationComponent";

import MKIDatatable from "../../../../../modules/mki-datatable/lib";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/menuService";

import DataTableBloc from "../Blocs/DataTableBloc";
import apiResponse from "../../../../../services/apiResponse";

import moment from "moment";
import { parseInt } from "lodash";
import Shimmer from "react-shimmer-effect";

class TablePenilaianDiriSendiriComponent extends Component {
  userdata = JSON.parse(localStorage.getItem("userdata"));
  is_eselon =
    typeof this.userdata.echelon_code === "string" &&
      (this.userdata.echelon_code.startsWith("1") ||
        this.userdata.echelon_code.startsWith("2"))
      ? 1
      : 0;

  dataTableBloc = new DataTableBloc();

  source;
  historyMonth = "penilaian_history_month_tunsus"; //
  historyYear = "penilaian_history_year_tunsus"; //
  historyTable = "historypenilaianTunjanganKhususTableActive"; // Nama di tiap tabel harus beda karena akan disimpan di session
  defaultOrder = "special_allowance_summary_id"; // orderBy
  defaultSize = 10;
  defaultSort = "desc";
  configDatatable = {
    ...config("datatable"),
    sort: {
      column: this.defaultOrder,
      order: this.defaultSort,
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      modalPresensi: false,
      modalPresensiUuid: null,
      modalPresensiFilter: null,
      tooltip: false,
      createUuid: null,
      updateUuid: null,
      previewUuid: null,
      inactiveUuid: null,
      activeUuid: null,
      defaultSize: 10,
      rows: [],
      totalRow: 0,
      loadingTable: true,
      runType: null,
      confirmInfo: "Apakah anda yakin akan melakukan verifikasi tunkin?",
      roleId: localStorage.getItem("currentRoleId"),
      filter: sessionStorage.getItem(this.historyTable)
        ? JSON.parse(sessionStorage.getItem(this.historyTable))
        : {
          filter_value: "",
          page_number: 1,
          page_size: this.defaultSize,
          sort_order: {
            column: this.defaultOrder,
            order: this.defaultSort,
          },
        },
      currentMonth: moment().format("M"),
      currentYear: moment().format("YYYY"),
      currentDay: parseInt(moment().format("D")),
      monthFilter: moment().format("M"),
      yearFilter: moment().format("YYYY"),
    };
  }
  toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });
  dateParse = (input) => {
    let res = "";
    if (input !== "" && input != null) {
      res = moment(input).format("DD/MM/YYYY");
    }
    return res;
  };

  loadData = async () => {
    /* history Datatable */
    sessionStorage.setItem(
      this.historyTable,
      JSON.stringify(this.state.filter)
    );

    localStorage.setItem(
      this.historyMonth,
      JSON.stringify(this.props.additionalFilter.month)
    );

    localStorage.setItem(
      this.historyYear,
      JSON.stringify(this.props.additionalFilter.year)
    );

    /* kirim ke server */
    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }
    const query = {
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: 1,
      roleId: 2, // ambil yang diri sendiri
      is_echelon: 0, // ambil yang diri sendiri
      ...this.props.additionalFilter,
    };
    await this.dataTableBloc.fetchRowTable(query, this.source.token);
  };

  checkCurrentMonth = () => {
    return parseInt(this.state.currentMonth) ==
      parseInt(this.state.monthFilter) &&
      parseInt(this.state.currentYear) == parseInt(this.state.yearFilter) &&
      this.state.currentDay >= 1 &&
      this.state.currentDay <= 10
      ? 1
      : 0;
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadData();
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  inactiveData = async () => {
    await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid });
  };
  activeData = async () => {
    await this.dataTableBloc.fetchActive({ uuid: this.state.activeUuid });
  };

  handleButtonExport = () => {
    // alert('ooooooooooooooo')
    this.dataTableBloc.fetchExport({
      month: this.props.additionalFilter.month,
      year: this.props.additionalFilter.year,
    });
  };

  componentDidMount() {
    this.setTokenAPI();

    this.dataTableBloc.rowtableChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            totalRow: response.total,
            rows: response.result,
            loadingTable: false,
          });
          this.props.setDocument(response?.document);
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    // this.dataTableBloc.inactiveChannel.subscribe((result) => {
    //   switch (result.status) {
    //     case apiResponse.COMPLETED:
    //       this.setState(
    //         {
    //           loading: false,
    //           success: true,
    //           loadingTable: true,
    //           inactiveUuid: null,
    //         },
    //         function () {
    //           this.setTokenAPI();
    //         }
    //       );
    //       break;
    //     case apiResponse.ERROR:
    //       this.setState({
    //         loading: false,
    //         failed: true,
    //       });
    //       break;
    //     default:
    //       break;
    //   }
    // });
    // this.dataTableBloc.activeChannel.subscribe((result) => {
    //   switch (result.status) {
    //     case apiResponse.COMPLETED:
    //       this.setState(
    //         {
    //           loading: false,
    //           success: true,
    //           loadingTable: true,
    //           activeUuid: null,
    //         },
    //         function () {
    //           this.setTokenAPI();
    //         }
    //       );
    //       break;
    //     case apiResponse.ERROR:
    //       this.setState({
    //         loading: false,
    //         failed: true,
    //       });
    //       break;
    //     default:
    //       break;
    //   }
    // });

    this.dataTableBloc.exportChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loading: true,
          });
          break;
        case apiResponse.COMPLETED:
          const link = result.data.response;
          window.open(link.file_url, "_blank");
          //window.location.href = link.file_url
          this.setState({
            loading: false,
            success: true,
          });
          setTimeout(() => {
            this.setState({
              success: false,
            });
          }, 1000);
          break;
        case apiResponse.ERROR:
          this.setState({
            urlFileDetail: link,
            loading: false,
            failed: true,
          });
          setTimeout(function () {
            this.setState({
              failed: false,
            });
          }, 1000);
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.dataTableBloc.rowtableChannel?.unsubscribe();
    // this.dataTableBloc.inactiveChannel?.unsubscribe();
    // this.dataTableBloc.activeChannel?.unsubscribe();
    this.dataTableBloc.exportChannel?.unsubscribe();
  }

  render() {
    let shimmer = (
      <Shimmer>
        <div
          style={{
            width: "3ch",
            height: "1rem",
            verticalAlign: "middle",
          }}
        ></div>
      </Shimmer>
    );

    var columns = [
      {
        key: "special_allowance_summary_employee_nip",
        text: "Pegawai",
        sortable: true,
        cell: (record) => {
          var plt = record.special_allowance_summary_plt_position_uuid;
          return (
            <span>
              <strong>{record.special_allowance_summary_employee_nip}</strong>
              <br></br>
              {record.special_allowance_summary_employee_name}
              <br></br>
              {/* {plt != null && plt != "" ? "Plt. " : ""} */}
              {record.special_allowance_summary_employee_current_position_name}
            </span>
          );
        },
      },
      {
        key: "special_allowance_summary_emp_grade_tunsus",
        text: "Grade",
        sortable: true,
        align: "center",
        cell: "-",
      },
      {
        key: "special_allowance_summary_presensi",
        // text:
        //   this.state.loadingTable === false ? (
        //     `Presensi \n (Bobot ${this.props.additionalFilter.presensi}%)`
        //   ) : (
        //     <Fragment>Presensi (Bobot {shimmer}%)</Fragment>
        //   ),
        sortable: true,
        align: "center",
        header: () => {
          return (
            <div className="text-center">
             Presensi<br />
             (Bobot {
             this.state.loadingTable === false ?
             this.props.additionalFilter.presensi:
             shimmer
             }%)
            </div>
          );
        },
        cell: (record) => {
          return (
            <span
              style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
              onClick={() => {
                this.setState({
                  modalPresensi: true,
                  modalPresensiUuid: record.special_allowance_summary_employe_uuid,
                  modalPresensiFilter: (() => {
                    let m = parseInt(record.special_allowance_summary_month) - 1;
                    let y = parseInt(record.special_allowance_summary_year);
                    if (m === 0) {
                        m = 12;
                        y = y - 1;
                    }
                    let mStr = m.toString().padStart(2, '0');
                    return {
                        start_date: moment(y + "-" + mStr + "-01").startOf('month').format('YYYY-MM-DD'),
                        end_date: moment(y + "-" + mStr + "-01").endOf('month').format('YYYY-MM-DD')
                    };
                  })()
                });
              }}
            >
              {record.special_allowance_summary_presensi
                ? record.special_allowance_summary_presensi
                : "-"}
              <br></br>(
              {record.special_allowance_summary_akumulasi_presensi
                ? record.special_allowance_summary_akumulasi_presensi
                : "-"}
              )
            </span>
          );
        },
      },

      {
        key: "special_allowance_summary_skp",
        // text:
        //   this.state.loadingTable === false ? (
        //     `Penilaian Kinerja Individu \n (Bobot ${this.props.additionalFilter.skp}%)`
        //   ) : (
        //     <Fragment>Penilaian Kinerja Individu (Bobot {shimmer}%)</Fragment>
        //   ),
        sortable: true,
        align: "center",
        header: () => {
          return (
            <div className="text-center">
             Penilaian Kinerja Individu<br />
             (Bobot {
             this.state.loadingTable === false ?
             this.props.additionalFilter.skp:
             shimmer
             }%)
            </div>
          );
        },
        cell: (record) => {
          return (
            <Fragment>
              {record.special_allowance_summary_skp
                ? record.special_allowance_summary_skp
                : "-"}
              <br></br>(
              {record.special_allowance_summary_final_result
                ? record.special_allowance_summary_final_result
                : "-"}
              )
            </Fragment>
          );
        },
      },

      {
        key: "special_allowance_summary_penilaian_pimpinan",
        // text:
        //   this.state.loadingTable === false ? (
        //     `Ekspektasi Pimpina \n (Bobot ${this.props.additionalFilter.penilaian}%)`
        //   ) : (
        //     <Fragment>Ekspektasi Pimpina (Bobot {shimmer}%)</Fragment>
        //   ),
        className: "text-center",
        // width: 120,
        sortable: true,
        align: "center",
        header: () => {
          return (
            <div className="text-center">
             Ekspektasi Pimpinan<br />
             (Bobot {
             this.state.loadingTable === false ?
             this.props.additionalFilter.penilaian:
             shimmer
             }%)
            </div>
          );
        },
        cell: (record) => {
          const thisId = record.special_allowance_uuid;
          let data_status = parseInt(record.special_allowance_status);
          return (
            <Fragment>
              {record.special_allowance_summary_penilaian_pimpinan
                ? record.special_allowance_summary_penilaian_pimpinan
                : "-"}
              <br></br>
              {/* Tambah dan Update Untuk Pegawai (Eselon 1 & 2) */}

              {accessRole("update") &&
                data_status === 1 &&
                this.state.roleId == 2 &&
                this.is_eselon == 1 ? (
                // is_eselon == 0) ? (
                <span>
                  <button
                    className="btn btn-primary btn-sm"
                    id={"preview-" + thisId}
                    onClick={() => {
                      this.setState({
                        previewUuid: thisId,
                      });
                    }}
                    style={{
                      marginRight: "2px",
                      padding: "2px 5px",
                    }}
                  >
                    <i className="uil-eye"></i> Lihat Hasil Penilaian
                  </button>
                  <Tooltip
                    style={{
                      marginBottom: 2,
                    }}
                    placement="top"
                    isOpen={this.state["preview" + thisId]}
                    target={"preview-" + thisId}
                    toggle={() => {
                      this.setState({
                        ["preview" + thisId]: !this.state["preview" + thisId],
                      });
                    }}
                  >
                    Lihat Hasil Penilaian
                  </Tooltip>
                </span>
              ) : null}
            </Fragment>
          );
        },
      },
      {
        key: "special_allowance_summary_total",
        text: "Nilai Akhir",
        sortable: true,
        align: "center",
        cell: "-",
      },
      // {
      //     key: "special_allowance_summary_status",
      //     text: "Status",
      //     sortable: true,
      //     cell: record => (record.special_allowance_summary_status === 1) ? <label className="badge rounded-pill bg-soft-info font-size-12" >Aktif</label> : <label className="badge rounded-pill bg-soft-warning font-size-12" >Nonaktif</label>
      // },
    ];
    return (
      <>
        <Modal isOpen={this.state.modalPresensi} toggle={() => this.setState({ modalPresensi: false })} size="xl" style={{ maxWidth: '95vw' }}>
          <ModalHeader toggle={() => this.setState({ modalPresensi: false })}>Detail Presensi</ModalHeader>
          <ModalBody style={{ padding: '10px', height: '80vh', overflowY: 'auto' }}>
            {this.state.modalPresensi && this.state.modalPresensiUuid ? (
              <SimulationComponent 
                uuid={this.state.modalPresensiUuid} 
                filter={this.state.modalPresensiFilter} 
                handleInactiveSuccess={() => {}}
              />
            ) : null}
          </ModalBody>
        </Modal>
        <MKIDatatable
          className={this.configDatatable.tableClass}
          config={this.configDatatable}
          records={this.state.rows}
          columns={columns}
          dynamic={true}
          minWidth={1000}
          total_record={this.state.totalRow}
          initial={this.state.filter}
          onChange={(filter) => {
            this.setState(
              {
                loadingTable: true,
                filter: filter,
              },
              function () {
                this.setTokenAPI();
              }
            );
          }}
          loading={this.state.loadingTable}
        />
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo={`Apakah anda yakin akan mengubah status data ini?`}
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil diubah"
          failedTitle="Gagal!"
          failedInfo="Data gagal diubah"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.createUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/penilaian_tunjangan_khusus.html?create_assestment&uuid=" +
              this.state.createUuid
            }
          />
        ) : null}
        {this.state.updateUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/penilaian_tunjangan_khusus.html?update_assestment&uuid=" +
              this.state.updateUuid
            }
          />
        ) : null}

        {this.state.previewUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/penilaian_tunjangan_khusus.html?preview_assestment&uuid=" +
              this.state.previewUuid
            }
          />
        ) : null}
      </>
    );
  }
}

export default TablePenilaianDiriSendiriComponent;
